import { createRoot } from 'react-dom/client';
import App from './App';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import indexStyles from './index.css?inline';
import { getAppTheme } from './theme/theme';

// Get host element
const host = document.getElementById('open-day-map-root');

if (!host) throw new Error('#open-day-map-root not found');

// Create shadow root
const shadowRoot = host.attachShadow({ mode: 'open' });

// Inject styles using adoptedStyleSheets
const sheet = new CSSStyleSheet();
sheet.replaceSync(indexStyles);
shadowRoot.adoptedStyleSheets = [sheet];

// Create React mount div inside shadow root
const reactRootDiv = document.createElement('div');
reactRootDiv.id = 'react-root';
shadowRoot.appendChild(reactRootDiv);

// Inject fonts
const fontsCssLink = document.createElement('link');
fontsCssLink.rel = 'stylesheet';
fontsCssLink.href = 'https://use.typekit.net/qji7bck.css?ver=3';
shadowRoot.appendChild(fontsCssLink);

// Inject Mazemap CSS
const mazemapCssLink = document.createElement('link');
mazemapCssLink.rel = 'stylesheet';
mazemapCssLink.href = 'https://api.mazemap.com/js/v2.2.5/mazemap.min.css';
shadowRoot.appendChild(mazemapCssLink);

// Create Emotion cache targeting shadow root
const cache = createCache({
    key: 'mui-shadow',
    container: shadowRoot,
    prepend: true,
});

// Create MUI theme with portal containers wired
const theme = getAppTheme(reactRootDiv);

createRoot(reactRootDiv).render(
    <CacheProvider value={cache}>
        <App
            emotionCache={cache}
            theme={theme}
        />
    </CacheProvider>,
);
